module.exports = __webpack_public_path__ + "static/media/poster.ef85828c.png";